module.exports = __webpack_public_path__ + "static/media/dot-scroll.79519252.svg";